import { render, staticRenderFns } from "./DesktopPlans_variant2.vue?vue&type=template&id=c5d7e440"
import script from "./DesktopPlans_variant2.vue?vue&type=script&lang=js"
export * from "./DesktopPlans_variant2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports